export default "__VITE_ASSET__DJqPWvUr__"